import loadable from '@loadable/component'

const RelatedCategories = loadable(
  () => import(
    './RelatedCategories.component'
  ),
)

export default RelatedCategories
